<template>
  <div
    class="flex flex-col"
    :class="{ 'm-6': !customMargin, 'h-full': fullHeight }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  customMargin?: boolean;
  fullHeight?: boolean;
}

const { customMargin = false, fullHeight = false } = defineProps<Props>();
</script>
